import styles from './request-service-loader.module.scss';
import { CatLoadingIndicator } from 'components/blocks-components';

const RequestServiceLoader = () => {
  return (
    <div
      className={`${styles['loader-container']} d-flex justify-content-center align-items-center w-100 h-100 position-absolute top-0 `}
    >
      <CatLoadingIndicator />
    </div>
  );
};

export default RequestServiceLoader;
